import { Component, Input, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SNItem, SNItemAccess } from 'src/app/models/snitem';
import { SNUser } from 'src/app/models/snuser';
import { ODBService } from 'src/app/services/odb.service';

@Component({
  selector: 'app-item-access-table',
  templateUrl: './item-access-table.component.html',
  styleUrls: ['./item-access-table.component.scss']
})
export class ItemAccessTableComponent implements OnInit {

  accessList: SNItemAccess[] = [];
  displayedColumns: string[] = ['user', 'read', 'write', 'change', 'locked'];

  private isEdit = false;
  private theItem: SNItem;
  public selectedUser: SNUser;
  public newAccess: SNItemAccess;

  constructor(private odb: ODBService) { }

  ngOnInit(): void {
  }

  @Input() set edit(isEdit: boolean) {
    this.isEdit = isEdit;
    if (this.isEdit) {
      this.displayedColumns = ['user', 'read', 'write', 'change', 'locked', 'icons'];
    }
  }

  @Input() set item(item: SNItem) {
    this.theItem = item;
    this.odb.itemAccess(item).subscribe(accesses => {
      this.accessList = accesses;
      if (this.isEdit) {
        // add an extra
        this.newAccess = new SNItemAccess(0, '', '', true, false, false, false, 0);
        this.accessList.push(this.newAccess);
      }
    });
  }

  changeReadAccess(access: SNItemAccess, event: MatSlideToggleChange) {
    if (access !== this.newAccess) {
      access.read = event.checked;
      this.odb.setItemAccess(this.theItem, [access]).subscribe(accesses => {
        this.accessList = accesses;
        if (this.isEdit) {
          this.accessList.push(this.newAccess);
        }
      });
    } else {
      access.read = event.checked;
    }
  }

  changeWriteAccess(access: SNItemAccess, event: MatSlideToggleChange) {
    if (access !== this.newAccess) {
      access.write = event.checked;
      this.odb.setItemAccess(this.theItem, [access]).subscribe(accesses => {
        this.accessList = accesses;
        if (this.isEdit) {
          this.accessList.push(this.newAccess);
        }
      });
    } else {
      access.write = event.checked;
    }
  }

  selectUser(user: SNUser) {
    this.selectedUser = user;
    this.newAccess.userid = this.selectedUser.id;
  }

  add() {
    this.odb.setItemAccess(this.theItem, [this.newAccess]).subscribe(accesses => {
      this.selectedUser = undefined;
      this.accessList = accesses;
      if (this.isEdit) {
        // add an extra
        this.newAccess = new SNItemAccess(0, '', '', true, false, false, false, 0);
        this.accessList.push(this.newAccess);
      }
    });
  }
}
